// Phrase playback stays off the chat speech path.
// It never sets chat state, and it will not interrupt the teacher.

let phraseUtterance = null;

const clearIfCurrent = (utterance) => {
  if (phraseUtterance === utterance) {
    phraseUtterance = null;
  }
};

const chineseVoice = () => {
  const voices = window.speechSynthesis.getVoices();
  return (
    voices.find((voice) => voice.lang.toLowerCase().startsWith('zh')) || null
  );
};

export const speakPhrase = (text) => {
  return new Promise((resolve) => {
    if (!text?.trim() || typeof window === 'undefined' || !window.speechSynthesis) {
      resolve();
      return;
    }

    const synth = window.speechSynthesis;
    const phraseIsPlaying = Boolean(phraseUtterance) && synth.speaking;

    if (synth.speaking && !phraseIsPlaying) {
      resolve();
      return;
    }

    const utterance = new SpeechSynthesisUtterance(text.trim());
    const voice = chineseVoice();
    if (voice) {
      utterance.voice = voice;
      utterance.lang = voice.lang;
    } else {
      utterance.lang = 'zh-CN';
    }
    utterance.rate = 0.92;

    utterance.onend = () => {
      clearIfCurrent(utterance);
      resolve();
    };
    utterance.onerror = () => {
      clearIfCurrent(utterance);
      resolve();
    };

    const start = () => {
      phraseUtterance = utterance;
      synth.speak(utterance);
    };

    if (phraseIsPlaying) {
      const previous = phraseUtterance;
      phraseUtterance = null;
      synth.cancel();
      clearIfCurrent(previous);
      // Chrome drops an utterance spoken in the same turn as cancel().
      window.setTimeout(start, 60);
      return;
    }

    start();
  });
};
